import React, {useState} from "react";
import {Dropdown} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    getSearchFilters,
    setTravelers,
} from "../../../redux/slices/searchFilterSlice";
import "./style.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-light-svg-icons";
import {faPlus, faMinus} from "@fortawesome/pro-solid-svg-icons";
import PropTypes from "prop-types";
import {toast} from "react-toastify";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";

const Travelers = ({setShowTraveler}) => {
    const dispatch = useDispatch();
    const {T} = useTranslationCustom();
    const searchfilters = useSelector(getSearchFilters);
    const [localTravelers, setLocalTravelers] = useState(searchfilters.travelers);

    const counterPlus = (index, type) => {
        let _travelers = [...localTravelers].map((traveler, i) => {
            if (index === i) {
                let counter = traveler[type];
                return {...traveler, [type]: counter + 1};
            }
            return traveler;
        });

        if (checkIfTravelsHasMax(_travelers) > 6) {
            return toast.info(T("Toasts:Max_Traveler_Description"));
        }

        setLocalTravelers(_travelers)
    };

    const counterMinus = (index, type) => {
        if (localTravelers[index][type] > 0) {
            let _travelers = [...localTravelers].map((traveler, i) => {
                if (index === i) {
                    let counter = traveler[type];
                    if (counter === 1 && type === "adult") return traveler;
                    return {...traveler, [type]: counter - 1};
                }
                return traveler;
            });

            if (checkIfTravelsHasMax(_travelers) > 6) {
                return toast.info(T("Toasts:Max_Traveler_Rooms_Description"));
            }

            setLocalTravelers(_travelers);
        }
    };

    const checkIfTravelsHasMax = _rooms => {
        return _rooms.reduce((total, room) => {
            return total + room.child + room.adult + room.infants;
        }, 0);
    };

    return (
        <Dropdown.Menu>
            {localTravelers?.map((traveler, index) => {
                return (
                    <div key={index}>
                        <div className="room-title">
                            <p className="d-titlle">
                                {T("Common:Room")} {index + 1}
                            </p>
                            {index !== 0 && (
                                <a
                                    onClick={() =>
                                        setLocalTravelers(
                                            [...localTravelers].filter(
                                                (f, i) => i !== index
                                            )
                                        )
                                    }
                                >
                                    <FontAwesomeIcon icon={faTimes}/>
                                </a>
                            )}
                        </div>
                        <li>
                            <div className="caption">
                                <p>{T("Common:Adults")}</p>
                            </div>
                            <div className="qty">
                                <a
                                    className="qty-action"
                                    onClick={() => counterMinus(index, "adult")}
                                >
                                    <FontAwesomeIcon icon={faMinus}/>
                                </a>
                                <p className="qty-val">{traveler?.adult}</p>
                                <a
                                    className="qty-action"
                                    onClick={() => counterPlus(index, "adult")}
                                >
                                    <FontAwesomeIcon icon={faPlus}/>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div className="caption">
                                <p>{T("Common:Child_Year_Range")}</p>
                            </div>
                            <div className="qty">
                                <a
                                    className="qty-action"
                                    onClick={() => counterMinus(index, "child")}
                                >
                                    <FontAwesomeIcon icon={faMinus}/>
                                </a>
                                <p className="qty-val">{traveler?.child}</p>
                                <a
                                    className="qty-action"
                                    onClick={() => counterPlus(index, "child")}
                                >
                                    <FontAwesomeIcon icon={faPlus}/>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div className="caption">
                                <p>{T("Common:Infants_Year_Range")}</p>
                            </div>
                            <div className="qty">
                                <a
                                    className="qty-action"
                                    onClick={() => counterMinus(index, "infants")}
                                >
                                    <FontAwesomeIcon icon={faMinus}/>
                                </a>
                                <p className="qty-val">{traveler?.infants}</p>
                                <a
                                    className="qty-action"
                                    onClick={() => counterPlus(index, "infants")}
                                >
                                    <FontAwesomeIcon icon={faPlus}/>
                                </a>
                            </div>
                        </li>
                    </div>
                );
            })}

            <div className="addmore-action">
                <a
                    onClick={() => {
                        const newRooms = [...localTravelers, {child: 0, adult: 1, infants: 0}];
                        if (checkIfTravelsHasMax(newRooms) > 6) {
                            return toast.info(T("Toasts:Max_Traveler_Description"));
                        }

                        if (newRooms.length > 3) {
                            return toast.info(T("Toasts:Max_Traveler_Rooms_Description"));
                        }
                        setLocalTravelers([...localTravelers, {child: 0, adult: 1, infants: 0}])
                    }}
                >
                    {T("Buttons:Add_Room")}
                </a>
                <a onClick={() => {
                    dispatch(setTravelers(localTravelers));
                    setShowTraveler(false);
                }}>{T("Buttons:Apply")}</a>
            </div>
        </Dropdown.Menu>
    );
};

Travelers.propTypes = {
    setShowTraveler: PropTypes.func
}


export default Travelers;
